import { Component, input } from '@angular/core';
import { RelativeTimePipe } from '@context/frontend/common';
import { getUaDevice } from '@context/frontend/native/platform';
import { User } from '@context/shared/types/user';
import { TranslocoModule } from '@jsverse/transloco';
import { TuiIcon, TuiSizeS } from '@taiga-ui/core';
import { TuiBadge } from '@taiga-ui/kit';
import { UserNamePipe, UserStatusPipe } from '../../pipes';
import { UserInviteExpiration } from '../../types/user-invite-expiration.model';
import { AvatarComponent } from '../avatar/avatar.component';
import { UserInviteExpirationRowComponent } from '../user-invite-expiration-row/user-invite-expiration-row.component';

@Component({
	imports: [
		AvatarComponent,
		UserNamePipe,
		UserInviteExpirationRowComponent,
		TuiIcon,
		TranslocoModule,
		TuiBadge,
		UserStatusPipe,
		RelativeTimePipe,
	],
	selector: 'ctx-user-row',
	templateUrl: 'user-row.component.html',
	styleUrl: 'user-row.component.scss',
	host: {
		'[attr.device]': 'device',
		'[attr.size]': 'size()',
	},
})
export class UserRowComponent {
	readonly device = getUaDevice();

	readonly user = input.required<User>();

	readonly interactable = input(true);

	readonly size = input<TuiSizeS>('m');

	readonly showStatus = input(true);

	/**
	 * When set (e.g. on user management list), shows invite expiration for pending users.
	 */
	readonly inviteExpiration = input<UserInviteExpiration | undefined>(
		undefined,
	);
}
